import React, {Component} from 'react';
import {API_URL} from "../../settings/local_settings";
import {APIClient} from "../../utils/APIClient";
import {Spinner} from "../Spinner";
import {SubmitButton} from "../buttons/SubmitButton";
import {withTranslation} from 'react-i18next';

class UserProfileInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            savingChanges: false,
            userInfo: null,
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    _editUserUrl() {
        return API_URL + 'user/' + this.props.userId;
    }

    getUserData() {
        new APIClient(this._editUserUrl()).call('GET').then((data) => {
            if (data.status === 'ERROR') {
                alert(data['error_message']);
                this.redirectToDashboard()
            } else if (data.status === 'OK') {
                this.setState({
                    userInfo: {
                        id: data.data.id,
                        name: data.data.name,
                        email: data.data.email,
                        timezone: data.data.timezone,
                        timezone_options: data.data.timezone_options,
                        language: data.data.language,
                        language_options: data.data.language_options
                    }
                });
            }
        })
    }

    componentDidMount() {
        this.getUserData();
    }

    handleSubmit() {
        this.setState({savingChanges: true});
        new APIClient(this._editUserUrl()).call('POST', {
            'name': this.state.userInfo.name,
            'language': this.state.userInfo.language,
            'timezone': this.state.userInfo.timezone,
        }).then((data) => {
            this.setState({savingChanges: false});
            let errors = [];
            if (data.status === 'ERROR') {
                errors = JSON.parse(data.errors);
            } else if (data.status === 'OK') {
                this.props.i18n.changeLanguage(this.state.userInfo.language);
                localStorage.setItem('i18nextLng', this.state.userInfo.language);
                this.props.afterSuccessfulSubmit();
            }
            this.setState({
                userInfo: {
                    ...this.state.userInfo,
                    errors: errors
                }
            });
        });
    }

    handleChange(event) {
        const target = event.target;
        const name = target.name;

        this.setState({
            userInfo: {
                ...this.state.userInfo,
                [name]: target.value
            }
        });
    }

    renderSaveButton() {
        const { t } = this.props;
        if (this.state.savingChanges) {
            return <Spinner color="positive small"/>;
        } else {
            return <SubmitButton onClick={this.handleSubmit} value={t('save_button')} />;
        }
    }

    renderUserInfo() {
        const { t } = this.props;
        if (this.state.userInfo !== null) {
            const timezone_options = (this.state.userInfo.timezone_options || []).map(opt => {
                return <option value={opt[0]} key={opt[0]}>{opt[1]}</option>
            });

            const language_options = (this.state.userInfo.language_options || []).map(opt => {
                return <option value={opt[0]} key={opt[0]}>{opt[1]}</option>
            });

            return (
                <div className="box">
                    <div className="form-row">
                        <label><span title={t('required_field')}>*</span>{t('name')}</label>
                        <input onChange={this.handleChange} name="name" type="text"
                            value={this.state.userInfo.name}/>
                    </div>
                    <div className="form-row">
                        <label>{t('email')}</label>
                        <input name="creatorName" type="text" readOnly="readonly"
                            className="form-control-plaintext"
                            value={this.state.userInfo.email}/>
                    </div>
                    <div className="form-row">
                        <label>{t('timezone')}</label>
                        <select name="timezone" value={this.state.userInfo.timezone || ''} onChange={this.handleChange}>
                            {timezone_options}
                        </select>
                    </div>
                    <div className="form-row">
                        <label>{t('language')}</label>
                        <select name="language" value={this.state.userInfo.language} onChange={this.handleChange}>
                            {language_options}
                        </select>
                    </div>
                </div>
            )
        } else {
            return (
                <div className="box-loader">
                    <Spinner color="positive"/>
                </div>
            )
        }
    }

    render() {
        return (
            <form className="section-body-item -slim">
                {this.renderUserInfo()}
                <div className="submit-row">
                    {this.renderSaveButton()}
                </div>
            </form>
        )
    }
}

export default withTranslation()(UserProfileInfo);

